import React, { useState, useRef, useEffect } from 'react';
import './book-package-select-v2.css';

const LargeItemDropdown = ({ 
  items = [], 
  value = null, 
  onChange, 
  placeholder = 'Select an option...',
  name = 'LargeItemDropdown',
  disabled = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (value) {
      const item = items.find(i => i.board_id === value);
      setSelectedItem(item || null);
    }
  }, [value, items]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelect = (item) => {
    setSelectedItem(item);
    setIsOpen(false);
    if (onChange) {
      onChange({ target: { name, value: item.board_id } });
    }
  };

  const formatText = (text) => {
    return text.split('\n').map((line, index) => {
      const trimmedLine = line.trim();
      if (!trimmedLine) return null;
      
      return (
        <div key={index} className="large-item-dropdown__text-line">
          {trimmedLine.startsWith('•') ? (
            <span className="large-item-dropdown__bullet-point">{trimmedLine}</span>
          ) : (
            <span>{trimmedLine}</span>
          )}
        </div>
      );
    });
  };

  return (
    <div className="large-item-dropdown" ref={dropdownRef}>
      <div 
        className={`large-item-dropdown__header ${disabled ? 'large-item-dropdown__header--disabled' : ''} ${isOpen ? 'large-item-dropdown__header--open' : ''}`}
        onClick={handleToggle}
      >
        <div className="large-item-dropdown__header-content">
          {selectedItem ? (
            <div className="large-item-dropdown__selected-item">
              {formatText(selectedItem.description.substring(0, 100) + (selectedItem.description.length > 100 ? '...' : ''))}
            </div>
          ) : (
            <span className="large-item-dropdown__placeholder">{placeholder}</span>
          )}
        </div>
        <span className={`large-item-dropdown__arrow ${isOpen ? 'large-item-dropdown__arrow--open' : ''}`}>
          ▼
        </span>
      </div>
      
      {isOpen && (
        <div className="large-item-dropdown__menu">
          {items.map((item) => (
            <div
              key={item.board_id}
              className={`large-item-dropdown__option ${selectedItem?.board_id === item.board_id ? 'large-item-dropdown__option--selected' : ''}`}
              onClick={() => handleSelect(item)}
            >
              <div className="large-item-dropdown__option-content">
                {formatText(item.description)}
              </div>
              {selectedItem?.board_id === item.board_id && (
                <span className="large-item-dropdown__checkmark">✓</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LargeItemDropdown;